import React from 'react';
import { Helmet } from 'react-helmet';
import BookingSection from '../components/BookingSection';
import { Car, MapPin, Clock } from 'lucide-react';

const TaxiBruges = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Helmet>
        <title>Taxi Bruges - Chauffeur Privé Luxe | Service VIP 24/7</title>
        <meta name="description" content="Service de taxi privé de luxe à Bruges. Chauffeur professionnel VIP, Mercedes & Lexus, disponible 24/7. Idéal tourisme." />
        <meta name="keywords" content="taxi bruges, chauffeur privé bruges, taxi brugge, vtc bruges, transfert bruges, taxi touristique bruges" />
        <link rel="canonical" href="https://www.luxurytransferservices.be/taxi-bruges" />
      </Helmet>

      <section className="relative bg-gradient-to-br from-gray-900 via-black to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-6xl font-bold text-center mb-6 bg-gradient-to-r from-gold via-yellow-300 to-gold bg-clip-text text-transparent">
            Taxi Bruges - Chauffeur Privé de Luxe
          </h1>
          <p className="text-xl text-gray-300 text-center mb-8">
            Service VIP à Bruges. Visites touristiques & transferts aéroport.
          </p>
        </div>
      </section>

      <section id="booking" className="py-12 bg-gray-900">
        <div className="container mx-auto px-4">
          <BookingSection defaultPickup="Bruges" />
        </div>
      </section>

      <section className="py-16 bg-gray-900">
        <div className="container mx-auto px-4 max-w-4xl">
          <h2 className="text-3xl font-bold text-gold mb-6">Taxi Privé à Bruges - Venise du Nord</h2>
          <p className="text-gray-300 mb-4">
            <strong>Taxi Bruges</strong> - Service de chauffeur privé premium pour découvrir la magnifique 
            ville médiévale de Bruges. Visites touristiques, transferts aéroport, excursions vers la côte belge. 
            Véhicules Mercedes & Lexus, chauffeurs guides francophones.
          </p>
          <h3 className="text-2xl font-bold text-gold mb-4 mt-8">Trajets & Visites Populaires</h3>
          <ul className="text-gray-300 space-y-2">
            <li>🚗 Bruges → Bruxelles (1h)</li>
            <li>🚗 Bruges → Gand (30 min)</li>
            <li>🚗 Bruges → Côte Belge (20 min)</li>
            <li>🚗 Bruges → Aéroport Zaventem (1h30)</li>
            <li>🏰 Tour de Bruges avec guide (2h)</li>
            <li>🏖️ Excursion Bruges + Côte (journée)</li>
          </ul>
        </div>
      </section>
    </div>
  );
};

export default TaxiBruges;